import { useCallback } from "react";
import { useStyle } from "./style";
import { DialpadItem, DialpadProps } from "./types";
import { Text, mergeClasses, Button } from "@fluentui/react-components";
import React from "react";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { Flex } from "@/components/atoms/flex";

export const Dialpad = (props: DialpadProps) => {
	const { onClick, onClose, isOutbound, isDisabled } = props;
	const classes = useStyle();

	const dialpadData: DialpadItem[] = [
		{
			digit: "1",
			text: "",
		},
		{
			digit: "2",
			text: "ABC",
		},
		{
			digit: "3",
			text: "DEF",
		},
		{
			digit: "4",
			text: "GHI",
		},
		{
			digit: "5",
			text: "JKL",
		},
		{
			digit: "6",
			text: "MNO",
		},
		{
			digit: "7",
			text: "PQRS",
		},
		{
			digit: "8",
			text: "TUV",
		},
		{
			digit: "9",
			text: "WXYZ",
		},
		{
			digit: "*",
			text: "",
		},
		{
			digit: "0",
			text: "",
		},
		{
			digit: "#",
			text: "",
		},
		{
			digit: "+",
			text: "",
		},
	];

	const getKeyButton = useCallback(
		(item: DialpadItem) => (
			<button
				key={item.digit}
				disabled={isDisabled}
				className={mergeClasses(
					classes.gridItem,
					isDisabled ? classes.gridItemDisabled : classes.gridItemHover
				)}
				onClick={() => onClick(item)}
			>
				<Text className={classes.gridItemDigit} children={item.digit} />
				<Text className={classes.gridItemText} children={item.text} />
			</button>
		),
		[props.destination, isDisabled]
	);

	const containerClass = isOutbound
		? classes.outboundContainer
		: classes.container;

	return (
		<div className={onClose === undefined ? containerClass : ""}>
			{onClose && (
				<Flex hAlign="flex-end">
					<Button
						appearance="transparent"
						icon={<Dismiss20Regular />}
						onClick={onClose}
					/>
				</Flex>
			)}

			<div className={classes.grid}>
				{dialpadData.map((item: DialpadItem) =>
					item.digit === "+" ? (
						<React.Fragment>
							<div className={classes.gridItem}></div>
							{getKeyButton(item)}
						</React.Fragment>
					) : (
						getKeyButton(item)
					)
				)}
			</div>
		</div>
	);
};
